import Loader from "common/components/Loader";

import useAgencySettings from "../../datahooks/useAgencySettings";
import CreateCustomization from "./CreateCustomization";
import Domains from "./Domains";
import Email from "./Email";
import Extension from "./Extension";
import Logo from "./Logo";
import AgencyName from "./Name";
import PrimaryColor from "./PrimaryColor";

export default function Whitelabel() {
  const { agencySettings, isLoadingAgencySettings } = useAgencySettings();

  if (isLoadingAgencySettings) {
    return <Loader />;
  }
  if (!agencySettings) {
    return <CreateCustomization />;
  }
  return (
    <div>
      <AgencyName />
      <PrimaryColor />
      <Logo />
      <Domains />
      <Email />
      <Extension />
    </div>
  );
}
